const CAMPAIGNS = [
    {
        title: 'First-to-market triggers',
        description:
            'Auto-send mail the moment pre-foreclosures, probates, tax delinquents, and other motivating events hit your market.',
        iconBg: 'bg-secondary/10',
        iconColor: 'text-secondary',
        icon: 'pulse',
        badge: 'Auto-trigger ready',
    },
    {
        title: 'Motivated list building',
        description:
            'Pull and stack lists around your buy box using property, owner, and behavioral data - not just equity and ZIP.',
        iconBg: 'bg-[#FAB331]/20',
        iconColor: 'text-secondary',
        icon: 'sun',
    },
    {
        title: 'Bulk mail campaigns',
        description:
            'High-volume drops built on a real strategy - audience, offer, format, and cadence - not just a list and a postcard.',
        iconBg: 'bg-[#DBEAFE]',
        iconColor: 'text-[#1E40AF]',
        icon: 'expand',
    },
    {
        title: 'Neighborhood farming',
        description:
            'Stay top of mind in the streets and ZIPs where you keep closing deals - recurring drops on autopilot.',
        iconBg: 'bg-[#DCFCE7]',
        iconColor: 'text-[#166534]',
        icon: 'map-pin',
        badge: 'Auto-trigger ready',
    },
    {
        title: 'Multi-touch campaigns',
        description:
            'Sequenced drops mixing postcards, letters, and handwritten formats to start a real conversation with sellers.',
        iconBg: 'bg-secondary/10',
        iconColor: 'text-secondary',
        icon: 'stack',
    },
    {
        title: 'A/B testing',
        description:
            "Test offers, formats, headlines, and lists drop over drop - then double down on what's actually producing deals.",
        iconBg: 'bg-gray-200',
        iconColor: 'text-gray-600',
        icon: 'checklist',
    },
]

const ADD_ONS = [
    {
        title: 'Call tracking numbers',
        description: 'Unique numbers per campaign, list, or drop.',
        icon: 'phone',
    },
    {
        title: 'QR code tracking',
        description: 'Tie scans back to the exact mail piece and offer.',
        icon: 'qr',
    },
    {
        title: 'Delivery tracking',
        description: 'See when mail hits the box, not just when it ships.',
        icon: 'delivery',
    },
    {
        title: 'Campaign reporting',
        description: 'Compare lists, offers, and creative drop over drop.',
        icon: 'chart',
    },
]

function CampaignIcon({ name, className }) {
    const icons = {
        pulse: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
        ),
        sun: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <circle cx="12" cy="12" r="4" />
                <path d="M12 2v2" />
                <path d="M12 20v2" />
                <path d="M4.93 4.93l1.41 1.41" />
                <path d="M17.66 17.66l1.41 1.41" />
                <path d="M2 12h2" />
                <path d="M20 12h2" />
                <path d="M4.93 19.07l1.41-1.41" />
                <path d="M17.66 6.34l1.41-1.41" />
            </svg>
        ),
        expand: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M16 3h5v5" />
                <path d="M21 3l-7 7" />
                <path d="M8 21H3v-5" />
                <path d="M3 21l7-7" />
                <rect x="10" y="10" width="4" height="4" />
            </svg>
        ),
        'map-pin': (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
            </svg>
        ),
        stack: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M4 4h16v4H4z" />
                <path d="M4 10h16v4H4z" />
                <path d="M4 16h16v4H4z" />
            </svg>
        ),
        checklist: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M9 11l3 3L22 4" />
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
            </svg>
        ),
    }
    return icons[name] || null
}

function AddOnIcon({ name, className }) {
    const icons = {
        phone: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
        ),
        qr: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
            </svg>
        ),
        delivery: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M3 7h18" />
                <path d="M3 12h18" />
                <path d="M3 17h18" />
                <path d="M8 3v18" />
            </svg>
        ),
        chart: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M3 3v18h18" />
                <polyline points="7 14 12 9 16 13 21 7" />
            </svg>
        ),
    }
    return icons[name] || null
}

function SparklesIcon({ className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            fill="none"
            width={12}
            height={12}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true">
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"></path>
        </svg>
    )
}

export default function CampaignStrategy() {
    return (
        <section className="bg-white">
            <div className="mx-auto max-w-7xl px-6 py-20 lg:px-8 lg:py-28">
                <div className="mb-10 flex max-w-3xl flex-col gap-4">
                    <span className="text-xs font-semibold uppercase tracking-widest text-secondary">
                        Investor campaign strategy
                    </span>
                    <h2
                        className="text-3xl font-bold tracking-tight text-[#3f454f] md:text-[44px]"
                        style={{ lineHeight: 1.05 }}>
                        Direct mail built around the deals you actually want
                        more of.
                    </h2>
                    <p
                        className="text-lg text-[color-mix(in_oklab,_#3F454F_70%,_transparent)]"
                        style={{ lineHeight: '28px' }}>
                        Reach the owners most likely to sell - with mail that
                        lands at the right moment, repeats with the right
                        cadence, and gets tracked back to the campaign that
                        worked.
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-5">
                    {CAMPAIGNS.map((campaign, i) => (
                        <div
                            key={i}
                            className="group relative flex flex-col gap-4 rounded-2xl border border-gray-200/50 bg-[#FFF7EC] p-6 transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl lg:p-7">
                            <div
                                className={
                                    campaign.badge
                                        ? 'flex flex-row items-start justify-between gap-3'
                                        : ''
                                }>
                                <div
                                    className={`flex h-12 w-12 items-center justify-center rounded-xl ${campaign.iconBg} transition-transform duration-300 ease-out group-hover:scale-110 group-hover:rotate-3`}>
                                    <CampaignIcon
                                        name={campaign.icon}
                                        className={`h-6 w-6 ${campaign.iconColor}`}
                                    />
                                </div>
                                {campaign.badge && (
                                    <div className="mt-2 -mr-2 -mt-2 flex flex-row items-center gap-1 rounded-full border border-secondary/30 bg-transparent px-2 py-px">
                                        <SparklesIcon className="h-3 w-3 text-secondary" />
                                        <span className="text-[0.625rem] font-bold uppercase leading-7 tracking-wider text-secondary">
                                            {campaign.badge}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <h3
                                className="text-lg font-bold text-[#3F454F] md:text-[22px]"
                                style={{ lineHeight: '28px' }}>
                                {campaign.title}
                            </h3>
                            <p
                                className="text-sm text-[color-mix(in_oklab,_#3F454F_65%,_transparent)]"
                                style={{ lineHeight: 1.625 }}>
                                {campaign.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="mx-auto max-w-7xl px-6 pb-20 lg:px-8 lg:pb-28">
                <div className="rounded-3xl border border-black/10 bg-[#FFF7EC] px-8 py-7 lg:px-12 lg:py-8">
                    <div className="mb-5 text-xs font-bold uppercase tracking-wider text-primary">
                        Available add-ons for any order
                    </div>
                    <div className="grid grid-cols-1 gap-6 lg:grid-cols-4 lg:gap-8">
                        {ADD_ONS.map((addOn) => (
                            <div
                                key={addOn.title}
                                className="flex flex-row items-start gap-4">
                                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white shadow-sm">
                                    <AddOnIcon
                                        name={addOn.icon}
                                        className="h-5 w-5 text-primary"
                                    />
                                </div>
                                <div className="flex flex-col gap-1">
                                    <div className="font-bold text-[#3F454F]">
                                        {addOn.title}
                                    </div>
                                    <div className="text-sm leading-relaxed text-[#3F454F]/65">
                                        {addOn.description}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
